import styled from '@emotion/styled'

const S = {
  Container: styled.div`
    .drawer {
      position: fixed;
      z-index: 1000;
      transition: transform 0.3s ease-in-out;
      width: 416px;
      height: 100%;
      background: #fff;

      &.left {
        top: 0;
        left: 0;
        transform: translateX(-100%);
      }
      &.right {
        top: 0;
        right: 0;
        transform: translateX(100%);
      }
    }

    &.open {
      .drawer {
        transform: translateX(0);
      }
      .overlay {
        visibility: visible;
        z-index: 999;
        pointer-events: auto;
      }
    }
  `,
  Overlay: styled.div`
    position: fixed;
    visibility: hidden;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;

    &.no-overlay {
      background: none;
    }
  `,
}

export default S
